const StringMask = require('string-mask');
const { personType, regexes } = require('@transfeeradev/api-enums');
const UtilsService = require('./UtilsService');
const BrV = require('br-validations');

const cnpjPattern = new StringMask('00.000.000/0000-00');
const cpfPattern = new StringMask('000.000.000-00');

class PersonTypeService {
  static format(document) {
    document = PersonTypeService.getCpfCnpjNumber(document);

    if (PersonTypeService.isCNPJ(document)) {
      return cnpjPattern.apply(document);
    } else if (PersonTypeService.isCPF(document)) {
      return cpfPattern.apply(document);
    }

    return document;
  }

  static getType(document) {
    if (PersonTypeService.isCNPJ(document)) {
      return personType.LEGAL;
    } else if (PersonTypeService.isCPF(document)) {
      return personType.PHYSICAL;
    }

    return null;
  }

  static isCPF(document) {
    return PersonTypeService.getCpfCnpjNumber(document).length === 11;
  }

  static isCNPJ(document) {
    return PersonTypeService.getCpfCnpjNumber(document).length === 14;
  }

  static getCpfCnpjNumber(document) {
    return UtilsService.getNumbersFromStr(document) || '';
  }

  static isValidCPF(cpf) {
    if (typeof cpf !== 'string') {
      cpf = String(cpf);
    }
    return BrV.cpf.validate(cpf);
  }

  static isValidCNPJ(cnpj) {
    if (typeof cnpj !== 'string') {
      cnpj = String(cnpj);
    }
    return BrV.cnpj.validate(cnpj);
  }

  static isSubsidiary(document) {
    if (!PersonTypeService.isCNPJ(document)) {
      return false;
    }
    document = String(PersonTypeService.getCpfCnpjNumber(document));
    const subsidiaryNumber = Number(document.substr(8, 4));
    return subsidiaryNumber !== 1;
  }

  static obfuscateCPF(cpf) {
    if (!PersonTypeService.isCPF(String(cpf))) {
      return cpf;
    }

    const formattedCPF = PersonTypeService.format(String(cpf));

    return `***${formattedCPF.substring(3, 12)}**`;
  }

  static isObfuscatedCPF(obfuscateCPF) {
    return regexes.CPF_OBFUSCATED.test(obfuscateCPF);
  }
}

module.exports = PersonTypeService;
